// Shared by static publication and browser navigation. IDs match panel owners;
// path segments stay stable across content languages.
export const PAGE_TABS = Object.freeze({
  dex: Object.freeze({ catalog: "catalog", progress: "progress", contest: "weekly-contest" }),
  calculator: Object.freeze({ basics: "basics", loadout: "loadout", loot: "loot", trade: "trade", data: "data", advanced: "advanced", custom: "custom" }),
});

export function pageTabPath(page, basePath, tab) {
  const tabs = PAGE_TABS[page];
  const segment = tabs && Object.hasOwn(tabs, tab) ? tabs[tab] : null;
  if (!segment || !basePath.startsWith("/") || !basePath.endsWith("/")) {
    throw new TypeError("Unknown page tab or invalid page base path");
  }
  return `${basePath}${segment}/`;
}

export function pageTabForPath(page, basePath, pathname) {
  if (pathname === basePath) return Object.keys(PAGE_TABS[page])[0];
  return Object.keys(PAGE_TABS[page]).find(tab => pageTabPath(page, basePath, tab) === pathname) ?? null;
}
